import React, { useState, lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Loader from "@/components/Loader";
import { AuthProvider } from "@/contexts/AuthContext";
import { LocationProvider } from "@/contexts/LocationContext";

// Dashboard, AuthModal and the custom cursor are not needed on the initial
// landing render — defer their JS until after first paint.
const Dashboard = lazy(() => import("@/pages/Dashboard"));
const AuthModal = lazy(() => import("@/components/AuthModal"));
const CustomCursor = lazy(() => import("@/components/CustomCursor"));

// Show the custom cursor on hover-capable devices only. This skips the
// import entirely on touch devices.
const supportsHover = typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(hover: hover)").matches;

export default function App() {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="App">
      <AuthProvider>
        <LocationProvider>
          <BrowserRouter>
            {!loaded && <Loader onDone={() => setLoaded(true)} />}
            {supportsHover && (
              <Suspense fallback={null}><CustomCursor /></Suspense>
            )}
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route
                path="/dashboard"
                element={
                  <Suspense fallback={<div className="grain min-h-screen" />}>
                    <Dashboard />
                  </Suspense>
                }
              />
            </Routes>
            <Suspense fallback={null}><AuthModal /></Suspense>
            <Toaster
              theme="dark"
              position="bottom-right"
              toastOptions={{
                style: {
                  background: "rgba(21,17,13,0.95)",
                  color: "#EFE6D6",
                  border: "1px solid rgba(239,230,214,0.08)",
                  borderRadius: "16px",
                  fontFamily: "Geist, sans-serif",
                },
              }}
            />
          </BrowserRouter>
        </LocationProvider>
      </AuthProvider>
    </div>
  );
}
